var _defs, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngryFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 314.21,
    y1: 209.66,
    x2: 1764.67,
    y2: 1843.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f72730"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1036.41,
    y1: 1020.38,
    x2: 1688.75,
    y2: 1661.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca4f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4511f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1017,
    y1: 1202.58,
    x2: 1017,
    y2: 1572.9,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 482.71,
    y1: 682.67,
    x2: 754.33,
    y2: 954.29,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1298.21,
    y1: 687.64,
    x2: 1566.07,
    y2: 936.63,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 518.24,
    y1: 718.2,
    x2: 712.35,
    y2: 912.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1334.91,
    y1: 721.75,
    x2: 1526.32,
    y2: 899.68,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1017,
    y1: 1249.31,
    x2: 1017,
    y2: 1527.05,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 650.34,
    y1: 394.67,
    x2: 650.34,
    y2: 610.42,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1383.66,
    y1: 394.67,
    x2: 1383.66,
    y2: 610.4,
    xlinkHref: "#linear-gradient-6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1017,1950.28c-523.28,0-949-425.72-949-949S493.72,52.28,1017,52.28s949,425.72,949,949-425.72,949-949,949Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.27,1672.01c171.84,171.84,409.09,278.27,670.73,278.27,523.28,0,949-425.72,949-949,0-261.64-106.43-498.89-278.27-670.73L346.27,1672.01Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M585.64,1562.09c-18.81,0-36.71-6-51.79-17.33-18.41-13.77-30.35-33.95-33.62-56.78-3.24-22.81,2.57-45.54,16.41-63.97,6.34-8.45,159.19-207.05,500.36-207.05s494.03,198.6,500.36,207.05c13.84,18.43,19.65,41.16,16.41,63.97-3.26,22.83-15.21,43.01-33.66,56.83-15.02,11.27-32.92,17.25-51.71,17.25-27.04,0-52.85-12.89-69.04-34.5-4.07-5.27-109.32-138.04-362.36-138.04s-358.28,132.82-362.68,138.47c-15.84,21.19-41.64,34.1-68.69,34.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M607.2,958.14c-83.24,0-150.98-67.74-150.98-150.98s67.74-150.98,150.98-150.98,150.98,67.74,150.98,150.98-67.74,150.98-150.98,150.98Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1426.8,958.14c-83.24,0-150.98-67.74-150.98-150.98s67.74-150.98,150.98-150.98,150.98,67.74,150.98,150.98-67.74,150.98-150.98,150.98Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 607.2,
    cy: 807.16,
    r: 107.84
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 1426.8,
    cy: 807.16,
    r: 107.84
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1448.41,1518.91c-13.12,0-26.08-5.96-34.54-17.25-4.74-6.17-122.31-155.3-396.86-155.3s-395.68,153.74-396.86,155.3c-14.24,19.04-41.24,23-60.39,8.61-19.06-14.28-22.92-41.32-8.61-60.39,5.81-7.75,146.03-189.8,465.86-189.8s460.05,182.04,465.86,189.8c14.3,19.06,10.45,46.11-8.61,60.39-7.77,5.83-16.85,8.64-25.84,8.64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M801.3,613.07c-5.67,0-11.44-1.14-16.98-3.52l-301.95-129.41c-21.88-9.37-32.04-34.73-22.64-56.64,9.33-21.91,34.69-32.12,56.64-22.64l301.95,129.41c21.88,9.37,32.04,34.73,22.64,56.64-6.99,16.34-22.92,26.16-39.66,26.16Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1232.7,613.07c-16.74,0-32.67-9.82-39.66-26.16-9.39-21.91.76-47.26,22.64-56.64l301.95-129.41c21.95-9.44,47.29.78,56.64,22.64,9.39,21.91-.76,47.26-22.64,56.64l-301.95,129.41c-5.54,2.38-11.31,3.52-16.98,3.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryFace);
export default __webpack_public_path__ + "static/media/Angry Face.ef62575cc0df58883d3be694f1c955ce.svg";
export { ForwardRef as ReactComponent };